import MobilePopupCarousel from './MobilePopupCarousel';

export default MobilePopupCarousel;
